import * as React from 'react';
import { SVGProps } from 'react';

const Copy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    {...props}
  >
    <path
      d="M10.2819 4.17969H5.70268C5.28116 4.17969 4.93945 4.52139 4.93945 4.94291V9.52218C4.93945 9.9437 5.28116 10.2854 5.70268 10.2854H10.2819C10.7035 10.2854 11.0452 9.9437 11.0452 9.52218V4.94291C11.0452 4.52139 10.7035 4.17969 10.2819 4.17969Z"
      stroke="#4D648B"
    />
    <path
      d="M8.78638 3.08179V2.68398C8.78638 2.26248 8.44468 1.92078 8.02316 1.92078H3.44386C3.02236 1.92078 2.68066 2.26248 2.68066 2.68398V7.26328C2.68066 7.6848 3.02236 8.0265 3.44386 8.0265H3.8253"
      stroke="#4D648B"
    />
  </svg>
);

export default Copy;
